// extracted by mini-css-extract-plugin
module.exports = {"minimumScreenWidth":"320px","mobileScreenWidth":"600px","root":"style_root__2ut4k","root__disabled":"style_root__disabled__2VG5X"};